import { Injectable } from '@angular/core';
import { SwUpdate, UnrecoverableStateEvent } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { interval, firstValueFrom } from 'rxjs';
import { RemoteLoggerService } from 'services/remote-logger.service';
import { VersionService } from 'services/version.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {
  constructor(
    private swUpdate: SwUpdate,
    private logger: RemoteLoggerService,
    private http: HttpClient,
    private versionService: VersionService
  ) {}

  initServiceWorkerListeners() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(filter((event) => event.type === 'VERSION_READY'))
        .subscribe(() => this.handleAvailableUpdate());

      // Handle unrecoverable situations such as cache eviction of an application
      // chunk that no longer exists on the server.
      this.swUpdate.unrecoverable.subscribe((e) =>
        this.handleUnrecoverableState(e)
      );

      //check version every 10 minutes
      interval(10 * 60 * 1000).subscribe(() =>
        this.swUpdate.checkForUpdate()
      );
    }
  }

  private handleUnrecoverableState(event: UnrecoverableStateEvent) {
    window.alert(
      `An error occurred that we cannot recover from:
          ${event.reason}
          Please reload the page.`
    );
    this.logger.capture(
      new Error(`Unrecoverable state encountered: ${event.reason}`)
    );
  }

  private async handleAvailableUpdate(): Promise<void> {
    // Get current version from version service
    const currentVersion = await firstValueFrom(this.versionService.getVersion()) || 'unknown';
    
    // Fire-and-forget: Post version update notification
    // The "to" version will be determined by the server endpoint
    this.http.post('/api/service-worker/version-update', {
      fromVersion: currentVersion
    }).subscribe();

    await this.swUpdate.activateUpdate();
    document.location.reload();
  }
}
